  <!-- The Modal-->
  <div class="modal" id="myUpgradeEnrolmentModal">

    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header gold-bg">
          <h4 class="modal-title">
            <span class="glyphicon glyphicon-lock"></span>
            Boldungu UpgradeEnrolment Form ({{studentDetail.fullname}})
            </h4>
            <button type="button" class="btn btn-danger" (click)="closeModal()">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" id="make_payment_form">
          <div class='form-group row mb-2' id="coupon" *ngIf="studentDetail.server_enrolment_id!=0">
            <label class='control-label col-sm-3'> Coupon</label>
            <div class='col-sm-8'><input name='coupon' placeHolder='Optional' class='form-control' formControlName="coupon" ></div>
          </div>
          <div class='form-group row alert alert-info' id="mybillingchoices" *ngIf="subscriptionChoices.length>0">
            <table class='table table-striped'>
              <tr *ngFor="let billChoice of subscriptionChoices; index as myCount">
                <td>
                  <input type='radio' name='subscription_choice' [value]="billChoice.name" [checked]="billChoice.name=='month'" (click)="onShowPaymentModes()" formControlName="subscription_choice"> {{billChoice.description}}
                </td>
              </tr>
            </table>
          </div>

           <div  *ngIf="showButtons">
             <fieldset class="buttons text-center">
               <button type="submit" class="btn btn-primary margin-50-right">Continue</button>
               <button type="button" class="btn btn-danger" (click)="closeModal()">Close</button>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
